import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class SamlAuthService {

  loginVia(idpKey: string, apiOrigin = environment.protocol + environment.apiUrl): Promise<any> {
    return new Promise((resolve, reject) => {
      const state = this.generateState();
      sessionStorage.setItem('saml_auth_state', state);
      console.log('SAML state', state);
      const w = 520, h = 640;
      const left = window.screenX + (window.outerWidth - w) / 2;
      const top = window.screenY + (window.outerHeight - h) / 2;
      const popup = window.open(
        `${apiOrigin}/v1/saml/start/${idpKey}?mode=popup&state=${encodeURIComponent(state)}`,
        'sso_popup', `width=${w},height=${h},left=${left},top=${top}`
      );
      if (!popup) {
        sessionStorage.removeItem('saml_auth_state');
        return reject(new Error('Popup blocked'));
      }

      const expectedOrigin = new URL(apiOrigin).origin;

      const onMsg = (e: MessageEvent) => {
        if (e.origin !== expectedOrigin) return;
        if (e.source !== popup) return;
        if (!e.data || e.data.tokenType !== 'Bearer') return;

        const expectedState = sessionStorage.getItem('saml_auth_state');
        if (!e.data.state || e.data.state !== expectedState) return;

        window.removeEventListener('message', onMsg);
        sessionStorage.removeItem('saml_auth_state');
        popup.close();
        resolve(e.data.user);
      };

      window.addEventListener('message', onMsg);
      setTimeout(() => {
        window.removeEventListener('message', onMsg);
        sessionStorage.removeItem('saml_auth_state');
        reject(new Error('Timeout'));
      }, 120000);
    });
  }

  private generateState(): string {
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);
    return Array.from(array, b => b.toString(16).padStart(2, '0')).join('');
  }
}